import React from 'react';
import { Rate } from 'antd';
import cx from 'classnames';
import './Rate.scss';

const CustomRate = (props) => {
  const { className, value, ...res } = props;

  return <Rate style={{ color: '#6200ea' }} className={cx('amondz-rate', className)} value={value} {...res} />;
};

export default CustomRate;
